import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'vendor/angular-pageslide-directive';

import contactModule from './screens/contact';
import faqModule from './screens/faq';
import iceTermsModule from './screens/ice-terms';
import landingModule from './screens/landing';
import privacyModule from './screens/privacy';
import confirmationModule from './screens/confirmation';
import passwordRecoveryModule from './screens/password-recovery';
import registrationModule from './screens/registration';
import termsModule from './screens/terms';

import guestHeaderComponent from 'guest-header';
import guestFooterComponent from 'guest-footer';

import guestComponent from './guest.component';

let guestModule = angular.module('guest', [
  'pageslide-directive',
  uiRouter,
  contactModule.name,
  faqModule.name,
  landingModule.name,
  privacyModule.name,
  confirmationModule.name,
  passwordRecoveryModule.name,
  registrationModule.name,
  termsModule.name,
  iceTermsModule.name,
])
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state('guest', {
        url: '',
        abstract: true,
        template: '<guest class="guest"></guest>',
      });
  })
  .component('guestHeader', guestHeaderComponent)
  .component('guestFooter', guestFooterComponent)
  .component('guest', guestComponent);

export default guestModule;



// WEBPACK FOOTER //
// ./src/app/screens/guest/index.js